import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Flex } from "@edreamsodigeo/prisma-design-system";
import ManageBookingsBannerAdvantageItem from "./ManageBookingsBannerAdvantageItem";
const ManageBookingsBannerAdvantages = () => {
  const {
    t
  } = useTranslation();
  const advantages = ["mytripsLogin.managebookings.banner.advantages.bagsandseats", "mytripsLogin.managebookings.banner.advantages.hotels", "mytripsLogin.managebookings.banner.advantages.support"];
  return /*#__PURE__*/React.createElement(Flex, {
    mt: ["", "big"],
    gap: ["1x_small", "base"],
    flexDirection: "column"
  }, advantages.map(advantage => /*#__PURE__*/React.createElement(ManageBookingsBannerAdvantageItem, {
    key: advantage
  }, t(advantage))));
};
export default ManageBookingsBannerAdvantages;